import React, { useEffect, useState } from 'react'
import { Box, Card, CardContent, Divider, Grid, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { getAccrualBalance } from '../../services/FunctionKeysService';
import CustomOutlinedButton from '../../components/CustomOutlined';
import { useNavigate } from 'react-router-dom';
import { REACT_FUNCTION_KEY_SCREEN } from '../../constants/ReactEndPoints';
import useScreenSize from '../../util/customHooks/useScreenSize';
import { useTranslation } from 'react-i18next';

const AccrualBalance = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [value, setValue] = useState(dayjs());
  const [data, setData] = useState([]);
  const { isMobile, isTablet, isLaptop } = useScreenSize();

  const formattedDate = value.format('YYYY-MM-DD');
  const currentFormatedDate = value.format('MM-DD-YYYY');

  useEffect(() => {
    fetchAccrualBalance();
  }, []);

  const fetchAccrualBalance = () => {
    getAccrualBalance(formattedDate)
      .then((res) => {
        if (res.status === 200 && res.data?.message === "Success") {
          setData(res.data?.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error while fetching accrual balance", error);
      });
  };

  const getDynamicHeight = () => {
    if (isMobile) return '45%';
    if (isTablet) return '52%';
    if (isLaptop) return '52%';
    return '58%';
  };

  return (
    <Box sx={{ margin: '25px 25px 0px 25px' }} width={'100%'}>

      {/* Title */}
      <Box sx={{ marginBottom: "5px" }}>
        <Typography variant='accrualBalanceLabel'>
          {t("accrualBalance.title", { date: currentFormatedDate })}
        </Typography>
      </Box>

      {/* Cards */}
      <Box
        sx={{
          minHeight: getDynamicHeight(),
          maxHeight: getDynamicHeight(),
          overflowY: 'auto',
          marginBottom: "10px"
        }}
      >
        <Grid container spacing={2}>
          {data.length > 0 ? (
            data.map((row, index) => (
              <Grid item xs={12} sm={6} md={3} lg={3} xl={2} key={index}>
                <Card sx={{ borderRadius: "10px" }}>
                  <CardContent>

                    {/* Accrued Time */}
                    <Box sx={{ margin: "0px 5px 10px 5px" }}>
                      <Typography variant="accuruedYear">
                        {t("accrualBalance.labels.timeType", {
                          value: row?.availableTime,
                          type: row?.timeType?.toLowerCase()
                        })}
                      </Typography>
                    </Box>

                    <Divider />

                    {/* Plan Name */}
                    <Box sx={{ margin: "10px 5px 0px 5px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      <Tooltip title={row.timeOffPlan} placement="bottom-start">
                        <Typography variant="timeOffPlan">
                          {row.timeOffPlan}
                        </Typography>
                      </Tooltip>
                    </Box>

                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Grid item xs={12} display="flex" justifyContent="center">
              <Typography>
                {t("accrualBalance.messages.noData")}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>

      {/* Back Button */}
      <Box sx={{ position: "absolute", left: "15px", bottom: "15px" }}>
        <CustomOutlinedButton
          onBtnClick={() => navigate(REACT_FUNCTION_KEY_SCREEN)}
          title={t("accrualBalance.buttons.back")}
        />
      </Box>

    </Box>
  );
};

export default AccrualBalance;
